import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../assets/apiopen_v1.png';
var _hoisted_1 = {
  class: "screen",
  src: _imports_0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("img", _hoisted_1);
}